import { defineStore } from 'pinia';
import { ref } from 'vue';
import catalogsAPI from '@/api/catalogs';
import type { Catalog } from '@/types/Catalog';
import { useAlertStore } from '@/store/alertStore';

export const useCatalogsStore = defineStore('catalogs', () => {
  const catalogs = ref<Catalog[]>([]);

  const alertStore = useAlertStore();
  
  const fetchCatalogs = async (): Promise<{ data: Catalog[] }> => {
    try {
      const response = await catalogsAPI.getCatalogs();
      const data: Catalog[] = response.data;
      catalogs.value = data;
      return { data };
    } catch (error) {
      console.error('Error fetching catalogs:', error);
      throw error;
    }
  };

  const updateCatalog = async (catalogData: Partial<Catalog>) => {
    try {
      const response = await catalogsAPI.updateCatalog(catalogData);
      if (!response.data.success) {
        throw response.data;
      }
      const updated = response.data.data as Catalog;
      const index = catalogs.value.findIndex((c:any) => c.id === catalogData.id);
      if (index !== -1) {
        catalogs.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating ${catalogData.name}(s):`, error);
      throw error;
    }
  };

  return {
    catalogs,
    fetchCatalogs,
    updateCatalog,
  };
});
